<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.EDIT') }} {{ $t('RELATED_COMPANIES.ITEM') }}</span
      >
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          :label="`${person.first_name} ${person.last_name}`"
          disabled
        ></v-text-field>

        <v-autocomplete
          v-model="relationModified.relatedId"
          :items="companies"
          :item-text="item => item.name"
          item-value="id"
          disabled
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATED_COMPANIES.ITEM')} *`"
        >
        </v-autocomplete>

        <v-autocomplete
          v-model="relationModified.relationshipId"
          :items="relationships"
          :loading="!!!relationships"
          item-value="id"
          item-text="name"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.RELATIONSHIP')} *`"
        ></v-autocomplete>

        <v-switch v-model="relationModified.key" :label="`Key`"></v-switch>

        <v-textarea
          v-model="relationModified.notes"
          outlined
          counter="80"
          :rules="rules.textDescription80"
          :label="$t('RELATIONS.NOTES')"
        ></v-textarea>

        <v-autocomplete
          v-model="relationModified.priorityId"
          :items="prioritiesList"
          item-text="title"
          item-value="id"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.PRIORITY')} *`"
        ></v-autocomplete>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>
            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
            >
              {{ $t('BUTTON.UPDATE') }}
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  requiredSelectNotArray,
  textDescription80
} from '@/modules/_global/variables/rules.js';
import priority from '@/modules/relations/components/mixins/priority';

export default {
  name: 'RelationsCompanyEdit',

  mixins: [priority],

  props: {
    person: {
      type: Object,
      required: true
    },
    relation: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    relationModified: {},
    error: null,
    valid: true,
    relationships: [],
    priorities: [],
    companies: [],
    rules: { requiredSelectNotArray, textDescription80 }
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  created() {
    this.relationModified = {
      id: this.relation.id,
      relatedId: this.relation.company_id,
      relationshipId: this.relation.relationship_id,
      key: this.relation.key,
      notes: this.relation.notes,
      priorityId: this.relation.priority
    };

    this.$store
      .dispatch('company/retrieveCompaniesByType', 3)
      .then(({ data }) => {
        this.companies = data;
      })
      .catch(error => {
        this.error = error.response;
      });

    this.$store
      .dispatch('relation/retrieveRelationshipsWithCompany')
      .then(response => {
        this.relationships = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });

    this.priorities = this.$store.state.relation.priorities;
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('relation/update', {
            type: 'company',
            person_id: this.person.id.toString(),
            related_id: this.relationModified.relatedId,
            relationship_id: this.relationModified.relationshipId,
            key: this.relationModified.key,
            notes: this.relationModified.notes,
            priority: this.relationModified.priorityId
          })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
            this.$store.commit('loading', false);
          })
          .catch(error => {
            this.error = error.response;
            this.$store.commit('loading', false);
          });
      }
    }
  }
};
</script>
